import {useIssueCreateConfigContext} from '../contexts/IssueCreateConfigContext'
import {useIssueCreateDataContext} from '../contexts/IssueCreateDataContext'
import {MetadataFooter} from './MetadataFooter'
import {MetadataSidebar} from './MetadataSidebar'

export type SharedMetadataProps = {
  repo: string
  owner: string
  canSetAssignees: boolean
  canSetLabels: boolean
  canSetMilestone: boolean
  canSetProjects: boolean
  canSetType: boolean
  canSetIssueFields: boolean
  canSetRelationships: boolean
  issueTypesEnabled: boolean
}

export const MetadataSelectors = () => {
  const {optionConfig} = useIssueCreateConfigContext()
  const showMetadataInSidebar = !optionConfig.insidePortal
  const {repository} = useIssueCreateDataContext()

  const canSetAssignees = repository?.viewerIssueCreationPermissions?.assignable ?? false
  const canSetLabels = repository?.viewerIssueCreationPermissions?.labelable ?? false
  const canSetMilestone = repository?.viewerIssueCreationPermissions?.milestoneable ?? false
  const canSetProjects = repository?.viewerIssueCreationPermissions?.triageable ?? false
  const canSetType = repository?.viewerIssueCreationPermissions?.typeable ?? false
  const canSetIssueFields = repository?.viewerIssueCreationPermissions?.canSetIssueFields ?? false
  const canSetRelationships = repository?.viewerIssueCreationPermissions?.triageable ?? false
  const issueTypesEnabled = repository?.owner?.issueTypesEnabled ?? false

  const sharedMetadataProps: SharedMetadataProps = {
    repo: repository?.name || '',
    owner: repository?.owner.login || '',
    canSetAssignees,
    canSetLabels,
    canSetMilestone,
    canSetProjects,
    canSetType,
    canSetIssueFields,
    canSetRelationships,
    issueTypesEnabled,
  }

  return showMetadataInSidebar ? (
    <MetadataSidebar {...sharedMetadataProps} />
  ) : (
    <MetadataFooter {...sharedMetadataProps} />
  )
}

try{ MetadataSelectors.displayName ||= 'MetadataSelectors' } catch {}